module.exports = __webpack_public_path__ + "img/time.15808416.png";